module.exports = __webpack_public_path__ + "static/DynamicAdvertisingOverview-22d7f4e9b3db2b013162c7886ca835f9.pdf";